import { motion } from "framer-motion";
import { SwooshRibbons } from "@/components/SwooshRibbons";

const steps = [
  { n: "01", name: "Talk", desc: "A short conversation about your goals, your team and your pipeline." },
  { n: "02", name: "Plan", desc: "One plan, with clear targets and a scope that suits your size." },
  { n: "03", name: "Run", desc: "I work alongside your team to build and run the outbound." },
  { n: "04", name: "Measure", desc: "Regular reporting on what is working, and what to change next." },
];

export const Process = () => (
  <section id="how" data-testid="process-section" className="relative overflow-hidden border-t border-white/5 bg-[#0B0A09] py-24 sm:py-32">
    <SwooshRibbons
      idPrefix="process-br"
      flip
      inView
      className="absolute -bottom-10 -right-28 h-[380px] w-[570px] opacity-70"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-16 max-w-2xl"
      >
        <p className="overline-tag mb-5">Framework</p>
        <h2 className="font-heading text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl">
          How it <span className="font-display italic text-blush">works</span>
        </h2>
        <p className="mt-4 text-base text-slate-400">
          A disciplined four-step framework for rapid commercial acceleration.
        </p>
      </motion.div>

      <div>
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`process-step-${s.n}`}
            className="grid grid-cols-12 items-baseline gap-4 border-t border-white/10 py-10 last:border-b sm:py-12"
          >
            <span className="col-span-3 font-mono text-sm text-ruby sm:col-span-2 sm:text-base">
              /{s.n}
            </span>
            <h3 className="col-span-9 font-heading text-2xl font-semibold tracking-tight text-slate-50 sm:col-span-4 sm:text-4xl">
              {s.name}
            </h3>
            <p className="col-span-9 col-start-4 mt-2 max-w-md text-base leading-relaxed text-slate-400 sm:col-span-6 sm:col-start-6 sm:mt-0">
              {s.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
